import type { ReactNode } from 'react';
import { EOIcon } from './EOIcon';

export interface EOModalProps {
  open: boolean;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  size?: '' | 'lg' | 'xl';
  onClose: () => void;
}

export function EOModal({ open, title, children, footer, size, onClose }: EOModalProps) {
  if (!open) return null;
  return (
    <div className="modal-scrim" onClick={onClose} role="presentation">
      <div
        className={`modal ${size ?? ''}`.trim()}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="eo-modal-title"
      >
        <div className="modal-head">
          <h3 id="eo-modal-title">{title}</h3>
          <button type="button" className="icon-x" onClick={onClose} aria-label="Close">
            <EOIcon n="x" size={18} />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer ? <div className="modal-foot">{footer}</div> : null}
      </div>
    </div>
  );
}
